import {ENUMS as enums} from "../services/enums";

const state = () => ({
  features: {
    "StorageIntegration": false,
    "EmailIntegration": false,
    "CalendarIntegration": false,
    "PhoneIntegration": false,
    "FollowUpSequence": false,
    "Webhooks": false,
    "Imports": false,
    "Exports": false,
    "EmailNotifications": false,
    "TextNotifications": false,
    "InviteUsers": false,
    "Automation": false,
    "CreatesPublicAssets": false,
    "AdvancedReporting": false,
    "SmrtPhoneIntegration": false,
    "MidTierPropertyData": false,
    "AdvancedTierPropertyData": false,
    "Comp": false,
    "PhoneSupport": false
  }
});

const getters = {
  hasWhiteGloveService(state, getters, rootGetters) {
    console.log('rootGetters.account.account', rootGetters.account.account)
    return rootGetters.account.account.supportServices.some(
      (s) => s.type === enums.SupportServicesTypeEnum.WhiteGlove.value
    );
  },
};

const mutations = {
  updateFeatures(state, account) {
    const keys = Object.keys(enums.FeatureEnum);

    keys.forEach(key => {
      const featureEnum = enums.FeatureEnum[key];
      state.features[featureEnum.key] = account[featureEnum.value];
    })
  }
};

const actions = {}

const AccountStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default AccountStore;
